import Heading, { HeadingLevel } from './Heading';

export default Heading;
export type { HeadingLevel };
